

export default function Exerciser159SingleValueAnswerInput({value, answerMaxLength, placeholder, onInputClicked}) {
    // Used in Exerciser that expects a typed single value as answer

    // BUILD
    return (
        <div className={"flex flex-col justify-start items-center"}>
            <div className={`mt-[24px] flex justify-center items-center cursor-auto select-none w-[256px] min-w-[256px] h-[56px] bg-transparent text-center border-[2px] border-primary rounded-[8px] py-[4px] ${renderTextStyle()}`}
                 onClick={onInputClicked} >
                {value || (placeholder ?? "")}
            </div>
            {value.length >= answerMaxLength
                ? <span className={"mt-[4px] text-secondaryLight4 font-normal text-[12px]"}>
                    {"Longueur maximale atteinte"}
                  </span>
                : null
            }
        </div>

    )

    // METHODS
    // ---- UI : Render text style
    function renderTextStyle() {
        return value === ""
            ? "text-greyLight5 font-normal text-[22px]"
            : "text-white font-medium text-[26px]"
    }
}